/**
 * DAVIDsTEA header — the account caret.
 *
 * The chevron beside the account icon is painted by dt-header as a pseudo-element on the wrapper
 * rather than being part of the control, because <shopify-account> renders its trigger inside a
 * shadow root that no theme stylesheet reaches. That leaves the caret outside the button's 44px:
 * it reads as part of the control but does nothing when clicked.
 *
 * The click is forwarded rather than the button widened. The trigger's width is declared inside
 * the shadow tree and holds against anything set on the host — 44.0 either way, even with the
 * host stretched to 64 — so there is no CSS answer from out here.
 *
 * Delegated from the document, so a header replaced by a section render in the theme editor keeps
 * working without rebinding.
 */
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const wrapper = target.closest('.account-button');
  if (!wrapper) return;

  /* A click on the icon already reached the control. It also arrives here retargeted to
     <shopify-account>, which is what stops the forwarded click below from coming back round. */
  if (target.closest('shopify-account')) return;

  const trigger = wrapper.querySelector('shopify-account')?.shadowRoot?.querySelector('button');
  trigger?.click();
});
